<div class="page-container">
    <p-toast [position]="'top-right'"></p-toast>

    <router-outlet></router-outlet>
    <!-- <app-file-upload [files]="files"></app-file-upload> -->
</div>